import axios from "../../config/axios";
import { useToast } from 'vue-toastification';
import Header from '@/components/header/Header.vue';
import Footer from '@/components/footer/Footer.vue';

const toast = useToast();

export default {
  name: 'UserEdit',
  components: {
    Header,
    Footer
  },
  data() {
    return {
      tel: '',
      address: '',
      provinceCode: '',
      wardCode: '',
      instructions: '',
      fullname: '',
      username: '',
      canEditUsername: true,
      yob: '',
      password: '',
      confirmPassword: '',
      showPassword: false,
      showConfirmPassword: false,
      isLoadingAccount: false,
      isLoadingAddress: false,
      errors: {
        tel: '',
        address: '',
        provinceCode: '',
        wardCode: '',
        instructions: '',
        fullname: '',
        username: '',
        yob: '',
        password: '',
        confirmPassword: ''
      },
      provinces: [],
      wards: [],
      quoteIndex: 0,
      quotes: [
        { text: "Một cuốn sách thực sự hay dạy tôi nhiều điều hơn là chỉ đọc nó. Tôi phải nhanh chóng đặt nó xuống, bắt đầu sống theo những gợi ý của nó.", author: "Henry David Thoreau" },
        { text: "Đọc sách không chỉ để thu thập kiến thức mà còn để rèn giũa tâm hồn và khám phá bản thân.", author: "Khuyết danh" },
        { text: "Sách mở ra những thế giới mới đầy kỳ diệu và đưa ta đến những nơi ta chưa từng mơ tới.", author: "Khuyết danh" }
      ],
      quoteTimer: null,
      showProvinceMenu: false,
      showWardMenu: false,
      accountName: '',
      accountRole: '',
      provinceSearchQuery: '',
      wardSearchQuery: ''
    };
  },
  computed: {
    isFromRegister() {
      return this.$route.query.from === 'register';
    },
    currentQuote() {
      return this.quotes[this.quoteIndex];
    },
    selectedProvinceName() {
      const found = this.provinces.find(p => p.code === this.provinceCode);
      return found ? found.name : '';
    },
    selectedWardName() {
      const found = this.wards.find(w => w.code === this.wardCode);
      return found ? found.name : '';
    },
    profileProgress() {
      const fields = [this.tel, this.provinceCode, this.wardCode, this.address, this.instructions];
      const filledCount = fields.filter(f => f !== null && f !== undefined && String(f).trim() !== '').length;
      return 90 + Math.round((filledCount / 5) * 10);
    },
    isProfileComplete() {
      const fields = [this.tel, this.provinceCode, this.wardCode, this.address, this.instructions];
      const filledCount = fields.filter(f => f !== null && f !== undefined && String(f).trim() !== '').length;
      return filledCount === 5;
    },
    filteredProvinces() {
      if (!this.provinceSearchQuery) return this.provinces;
      const q = this.removeDiacritics(this.provinceSearchQuery);
      return this.provinces.filter(p => this.removeDiacritics(p.name).includes(q));
    },
    filteredWards() {
      if (!this.wardSearchQuery) return this.wards;
      const q = this.removeDiacritics(this.wardSearchQuery);
      return this.wards.filter(w => this.removeDiacritics(w.name).includes(q));
    }
  },
  watch: {
    provinceCode(newVal) {
      if (newVal) {
        this.loadWards(newVal);
      } else {
        this.wards = [];
      }
    }
  },
  mounted() {
    if (this.$route.path === '/user-edit' && !this.isFromRegister) {
      this.$router.replace('/settings/profile');
      return;
    }
    this.loadProvinces();
    this.startQuoteRotation();
    const currentAccountStr = localStorage.getItem('current-account');
    if (currentAccountStr) {
      try {
        const currentAccount = JSON.parse(currentAccountStr);
        this.tel = currentAccount.tel || currentAccount.phone || currentAccount.telephone || '';
        this.address = currentAccount.address || '';
        this.instructions = currentAccount.instructions || '';
        this.accountName = currentAccount.fullName || currentAccount.fullname || currentAccount.name || currentAccount.username || '';
        this.fullname = currentAccount.fullName || currentAccount.fullname || currentAccount.name || '';
        this.canEditUsername = !!(currentAccount.username && currentAccount.username.startsWith('[DRAFF]'));
        this.username = (currentAccount.username && !currentAccount.username.startsWith('[DRAFF]')) ? currentAccount.username : '';
        this.yob = currentAccount.yob ? currentAccount.yob : '';
        this.accountRole = currentAccount.authority || '';
        this.provinceCode = currentAccount.provinceCode || '';
        this.wardCode = currentAccount.wardCode || '';
        if (this.provinceCode) {
          this.loadWards(this.provinceCode);
        }
      } catch (e) {
        console.error('Error parsing current-account:', e);
      }
    }

    // Fetch latest fresh profile info from server
    axios.get("account/get-infor")
      .then(response => {
        if (response.data && response.data.status === '200' && response.data.result) {
          const info = response.data.result;
          this.tel = info.tel || this.tel || '';
          this.address = info.address || this.address || '';
          this.instructions = info.instructions || this.instructions || '';
          this.fullname = info.fullname || this.fullname || '';
          this.accountName = info.fullname || info.username || this.accountName || '';
          this.canEditUsername = !!(info.username && info.username.startsWith('[DRAFF]'));
          this.username = (info.username && !info.username.startsWith('[DRAFF]')) ? info.username : '';
          this.yob = info.yob !== null && info.yob !== undefined ? info.yob : this.yob;
          this.provinceCode = info.provinceCode || this.provinceCode || '';
          this.wardCode = info.wardCode || this.wardCode || '';
          if (this.provinceCode) {
            this.loadWards(this.provinceCode);
          }

          if (currentAccountStr) {
            try {
              const currentAccount = JSON.parse(currentAccountStr);
              currentAccount.tel = info.tel;
              currentAccount.address = info.address;
              currentAccount.provinceCode = info.provinceCode;
              currentAccount.wardCode = info.wardCode;
              currentAccount.instructions = info.instructions;
              currentAccount.fullName = info.fullname;
              currentAccount.username = info.username;
              currentAccount.yob = info.yob;
              localStorage.setItem('current-account', JSON.stringify(currentAccount));
            } catch (e) {}
          }
        }
      })
      .catch(err => {
        console.error("Error fetching latest profile from server:", err);
      });

    window.addEventListener('click', this.handleWindowClick);
  },
  beforeUnmount() {
    if (this.quoteTimer) {
      clearInterval(this.quoteTimer);
    }
    window.removeEventListener('click', this.handleWindowClick);
  },
  methods: {
    removeDiacritics(str) {
      if (!str) return '';
      return str.normalize('NFD')
                .replace(/[\u0300-\u036f]/g, '')
                .replace(/đ/g, 'd')
                .replace(/Đ/g, 'D')
                .toLowerCase();
    },
    startQuoteRotation() {
      this.quoteTimer = setInterval(() => {
        this.quoteIndex = (this.quoteIndex + 1) % this.quotes.length;
      }, 6000);
    },
    toggleProvinceDropdown(e) {
      e.stopPropagation();
      this.showProvinceMenu = !this.showProvinceMenu;
      this.showWardMenu = false;
      this.provinceSearchQuery = '';
      if (this.provinces.length === 0) {
        this.loadProvinces();
      }
      if (this.showProvinceMenu) {
        this.$nextTick(() => {
          if (this.$refs.provinceSearchInputReg) this.$refs.provinceSearchInputReg.focus();
          if (this.$refs.provinceSearchInputEdit) this.$refs.provinceSearchInputEdit.focus();
        });
      }
    },
    toggleWardDropdown(e) {
      e.stopPropagation();
      this.showWardMenu = !this.showWardMenu;
      this.showProvinceMenu = false;
      this.wardSearchQuery = '';
      if (this.wards.length === 0 && this.provinceCode) {
        this.loadWards(this.provinceCode);
      }
      if (this.showWardMenu) {
        this.$nextTick(() => {
          if (this.$refs.wardSearchInputReg) this.$refs.wardSearchInputReg.focus();
          if (this.$refs.wardSearchInputEdit) this.$refs.wardSearchInputEdit.focus();
        });
      }
    },
    selectProvince(province) {
      if (this.provinceCode !== province.code) {
        this.provinceCode = province.code;
        this.wardCode = '';
      }
      this.showProvinceMenu = false;
      this.provinceSearchQuery = '';
      this.clearError('provinceCode');
    },
    selectWard(ward) {
      this.wardCode = ward.code;
      this.showWardMenu = false;
      this.wardSearchQuery = '';
      this.clearError('wardCode');
    },
    handleWindowClick() {
      this.showProvinceMenu = false;
      this.showWardMenu = false;
      this.provinceSearchQuery = '';
      this.wardSearchQuery = '';
    },
    clearError(field) {
      this.errors[field] = '';
    },
    validateAccountForm() {
      let isValid = true;
      this.clearError('fullname');
      this.clearError('username');
      this.clearError('yob');
      this.clearError('password');
      this.clearError('confirmPassword');

      if (!this.fullname || this.fullname.trim().length < 5) {
        this.errors.fullname = "Họ và tên phải có ít nhất 5 ký tự";
        isValid = false;
      }
      if (!this.username || this.username.trim().length < 5 || !/^[a-zA-Z0-9]+$/.test(this.username)) {
        this.errors.username = "Tên đăng nhập không hợp lệ (tối thiểu 5 ký tự, không chứa ký tự đặc biệt)";
        isValid = false;
      }
      if (!this.yob || this.yob < 1920 || this.yob > new Date().getFullYear() - 13) {
        this.errors.yob = "Năm sinh không hợp lệ";
        isValid = false;
      }
      if (this.canEditUsername) {
        // Tài khoản Nháp ([DRAFF]): bắt buộc nhập mật khẩu mới và xác nhận
        if (!this.password) {
          this.errors.password = "Vui lòng nhập mật khẩu mới";
          isValid = false;
        } else if (this.password.length < 6 || !/^[a-zA-Z0-9]+$/.test(this.password)) {
          this.errors.password = "Mật khẩu không hợp lệ (tối thiểu 6 ký tự)";
          isValid = false;
        }

        if (!this.confirmPassword) {
          this.errors.confirmPassword = "Vui lòng xác nhận mật khẩu mới";
          isValid = false;
        } else if (this.password && this.password !== this.confirmPassword) {
          this.errors.confirmPassword = "Mật khẩu xác nhận không khớp";
          isValid = false;
        }
      } else {
        // Tài khoản đã chính thức: Mật khẩu là tùy chọn
        if (this.password) {
          if (this.password.length < 6 || !/^[a-zA-Z0-9]+$/.test(this.password)) {
            this.errors.password = "Mật khẩu không hợp lệ (tối thiểu 6 ký tự)";
            isValid = false;
          }
          if (this.password !== this.confirmPassword) {
            this.errors.confirmPassword = "Mật khẩu xác nhận không khớp";
            isValid = false;
          }
        }
      }
      return isValid;
    },
    validateAddressForm() {
      let isValid = true;
      this.clearError('tel');
      this.clearError('address');
      this.clearError('provinceCode');
      this.clearError('wardCode');
      this.clearError('instructions');

      if (!this.isFromRegister || this.tel) {
        if (!this.tel) {
          this.errors.tel = "Vui lòng nhập số điện thoại";
          isValid = false;
        } else if (!/^(03|05|07|08|09)\d{8}$/.test(this.tel)) {
          this.errors.tel = "Số điện thoại không hợp lệ";
          isValid = false;
        }
      }

      if (!this.isFromRegister || this.address) {
        if (!this.address) {
          this.errors.address = "Vui lòng nhập địa chỉ chi tiết";
          isValid = false;
        } else if (this.address.length > 200) {
          this.errors.address = "Địa chỉ không được quá 200 ký tự";
          isValid = false;
        }
      }

      if (!this.isFromRegister) {
        if (!this.provinceCode) {
          this.errors.provinceCode = "Vui lòng chọn tỉnh/thành phố";
          isValid = false;
        }

        if (!this.wardCode) {
          this.errors.wardCode = "Vui lòng chọn xã/phường";
          isValid = false;
        }
      }

      if (this.instructions && this.instructions.length > 500) {
        this.errors.instructions = "Hướng dẫn không được quá 500 ký tự";
        isValid = false;
      }

      return isValid;
    },
    sendUpdateRequest(loadingFlag) {
      this[loadingFlag] = true;

      const requestData = {
        tel: this.tel?.trim() || null,
        address: this.address?.trim() || null,
        provinceCode: this.provinceCode || null,
        wardCode: this.wardCode || null,
        instructions: this.instructions?.trim() || null,
        fullname: this.fullname?.trim() || null,
        username: this.username?.trim() || null,
        yob: this.yob || null,
        password: this.password || null
      };

      axios.post("account/update-infor", requestData)
        .then(response => {
          if (response.data.status === '200') {
            toast.success(response.data.message);
            this[loadingFlag] = false;
            
            // Clear password inputs and reset eye toggle
            this.password = '';
            this.confirmPassword = '';
            this.showPassword = false;
            this.showConfirmPassword = false;

            const updatedResult = response.data.result;
            const currentAccountStr = localStorage.getItem('current-account');
            if (currentAccountStr) {
              try {
                const currentAccount = JSON.parse(currentAccountStr);
                if (updatedResult) {
                  currentAccount.tel = updatedResult.tel;
                  currentAccount.address = updatedResult.address;
                  currentAccount.provinceCode = updatedResult.provinceCode;
                  currentAccount.wardCode = updatedResult.wardCode;
                  currentAccount.instructions = updatedResult.instructions;
                  currentAccount.status = updatedResult.status;
                  currentAccount.fullName = updatedResult.fullname || updatedResult.fullName;
                  currentAccount.username = updatedResult.username || currentAccount.username;
                  currentAccount.yob = updatedResult.yob || currentAccount.yob;
                }
                localStorage.setItem('current-account', JSON.stringify(currentAccount));
                this.canEditUsername = !!(currentAccount.username && currentAccount.username.startsWith('[DRAFF]'));
              } catch (e) {
                toast.success(this.isFromRegister ? 'Đã hoàn thiện hồ sơ!' : 'Cập nhật thành công!');
              }
            }
            
            if (this.isFromRegister) {
              this.$router.push('/search-preferences?from=register');
            }
          } else if (response.data.status === '201') {
            toast.warning(response.data.message);
            this[loadingFlag] = false;
            if (this.isFromRegister) {
              this.$router.push('/search-preferences?from=register');
            }
          } else if (response.data.status === '500') {
            this[loadingFlag] = false;
            toast.error(response.data.message);
          }
        })
        .catch(error => {
          this[loadingFlag] = false;
          toast.error(error.response?.data?.message || error.message);
        });
    },
    handleUpdateAccount() {
      if (!this.validateAccountForm()) return;
      this.sendUpdateRequest('isLoadingAccount');
    },
    handleUpdateAddress() {
      if (!this.validateAddressForm()) return;
      this.sendUpdateRequest('isLoadingAddress');
    },
    skipUpdate() {
      if (this.isFromRegister) {
        this.$router.push('/search-preferences?from=register');
      } else {
        this.$router.push('/');
      }
    },
    togglePassword() {
      this.showPassword = !this.showPassword;
    },
    toggleConfirmPassword() {
      this.showConfirmPassword = !this.showConfirmPassword;
    },
    loadProvinces() {
      axios.get("common/get-all-provinces")
        .then(response => {
          if (response.data.status === '200' && response.data.result) {
            this.provinces = response.data.result;
          }
        })
        .catch(error => {
          console.error('Error loading provinces:', error);
        });
    },
    loadWards(provinceCode) {
      if (!provinceCode) {
        this.wards = [];
        return;
      }

      axios.get(`common/get-wards-by-province/${provinceCode}`)
        .then(response => {
          if (response.data.status === '200' && response.data.result) {
            this.wards = response.data.result;
          } else {
            this.wards = [];
          }
        })
        .catch(error => {
          console.error('Error loading wards:', error);
          this.wards = [];
        });
    }
  }
};
